import { AfterViewInit, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { CollectionService } from '@services/collection.service';
import { NotificationService } from '@services/notification.service';
import { RoleManagementService } from '@services/role.management.service';
import { ShareDataService } from '@services/share-data.service';
import { UsersService } from '@services/users.service';
import { Subject, Subscription } from 'rxjs';
import { AddUSerDialog } from 'src/app/collection/collection-users/add-user-dialog';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { AccountAdminRole } from '@configs/role.config';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
export interface UserData {
  firstName: string;
  lastName: string;
  phone: string;
  emailId: string;
  active: boolean;
  modifiedDateTime: string;
}

export class SelecteRole {
  active: boolean;
  collectionId: number;
  collectionUserId: number;
  collectionUsersuuId: any;
  collectionuuId: any;
  deleted: boolean;
  emailId: string;
  firstName: string;
  lastName: string;
  modifiedDateTime: string;
  phone: number;
  userAccessLevelId: number;
  userAccessLevel: string;
  useruuid: number;
  useraccessLevels: any;
  status: any;
  roleSelection: any;
  modifiedUserName: any;
  adminRole: any;
  totalAccountAdminCount: number;
}

@Component({
  selector: 'app-collection-users',
  templateUrl: './collection-users.component.html',
  styleUrls: ['./collection-users.component.scss'],
})
export class CollectionUsersComponent
  implements OnInit, AfterViewInit, OnDestroy {
  displayedColumns: string[] = [
    'firstName',
    'lastName',
    'phone',
    'email',
    'role',
    'status',
    'modifiedDate',
    'delete',
  ];
  collectionUsersData$: Subscription | undefined;
  dataSource: MatTableDataSource<UserData>;
  globalcollectionid: any;
  globalcollectionuuId: any;
  isNoUsers = false;
  page: number = 1;
  clientFirstName = '';
  clientLastName = '';
  clientStatus = '';
  userRoleFilter = '';
  selectStatus: any = 'Status';
  statusFilter: any;
  userRoles = [];
  newarray: any;
  statusArray = [
    { status: 'Status' },
    { status: 'Active' },
    { status: 'Inactive' },
  ];
  addnewUsertoCollection = false;
  updateroleValue: any;
  assignUserRole: any;
  collectionUserId: any;
  selectedUserRole: any;
  selecteRole = new SelecteRole();
  newselect: any;
  newDataSourceArray = [];
  isActive = false;
  selectFilterRole: any = 'Role';
  selectedState: any;
  defaultSelectedRole: any;
  currentUserData: any;
  currentUserFlag: boolean;
  accountAdmin: AccountAdminRole;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  userFilterServiceSubscription$: Subscription | undefined;
  usersData: any;
  noDataFound = false;
  collectionUserData: any;
  dropdownSettings = {};
  userAccessLevelId: any;
  selectedRole: any = '';
  selectedRoles: any;
  AccountAdminRole: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  showPaginator = false;

  constructor(
    public roleSer: RoleManagementService,
    private collectionService: CollectionService,
    private shareDataService: ShareDataService,
    private router: Router,
    private routerState: ActivatedRoute,
    private appService: AppService,
    public dialog: MatDialog,
    private usersService: UsersService,
    private notificationService: NotificationService,
    private ngzone: NgZone,
    private webErrorService: WebErrorService,
    private translate: TranslateService
  ) {
    this.AccountAdminRole = AccountAdminRole.accountAdmin;
    this.collectionService.addColuser.subscribe((data) => {
      this.collectionService
        .getCollectionUsers(this.globalcollectionuuId)
        .subscribe((resData) => {
          this.getCollectionUserList(resData?.data);
        });
    });
  }
  ngOnInit(): void {
    this.currentUserData = JSON.parse(sessionStorage.currentUser);
    this.appService.changeUserHeader(1);
    this.globalcollectionid = JSON.parse(
      sessionStorage.getItem('defaultcollectionid')
    );

    this.globalcollectionuuId =
      JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));



    this.collectionService.getRoleList().subscribe(role => {
      this.userRoles = role?.data;
    }, (error: any) => { this.webErrorService.handleAPIErrors(error); });
    // this.collectionService.getUserRoles().subscribe((role) => {
    //   this.userRoles1 = role?.items;
    // });

    this.collectionUsersData$ = this.collectionService
      .getCollectionUsers(this.globalcollectionuuId)
      .subscribe((assignUsers) => {
        this.getCollectionUserList(assignUsers?.data);
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); });


    this.dropdownSettings = {
      singleSelection: false,
      idField: 'roleId',
      textField: 'roleName',
      itemsShowLimit: 3,
      selectAllText: this.translate.instant('collectionById.collectionUsers.selectAll')
    };
  }

  getCollectionUserList(data): void {
    if (data) {
      if (data?.length > 0) {
        this.isNoUsers = false;
      } else {
        this.isNoUsers = true;
      }
      this.newarray = [];
      this.selectedUserRole = data;
      this.selectedUserRole.forEach((element) => {
        const selecteRole = new SelecteRole();
        selecteRole.active = element?.active;
        selecteRole.collectionId = element?.collectionId;
        selecteRole.collectionuuId = sessionStorage.getItem('defaultcollectionuuid');
        selecteRole.collectionUserId = element?.collectionUserId;
        selecteRole.collectionUsersuuId = element?.collectionUsersuuId;
        selecteRole.deleted = element?.deleted;
        selecteRole.emailId = element?.emailId;
        selecteRole.firstName = element?.firstName;
        selecteRole.lastName = element?.lastName;
        selecteRole.modifiedDateTime = element?.modifiedDateTime;
        selecteRole.phone = element?.phone;
        selecteRole.userAccessLevelId = element?.userAccessLevelId;
        selecteRole.userAccessLevel = element?.userAccessLevel;
        selecteRole.useruuid = element?.useruuid;
        selecteRole.adminRole = element?.useraccessLevels.filter(e => e.roleName == AccountAdminRole.accountAdmin);
        selecteRole.adminRole = selecteRole.adminRole.length > 0 ? selecteRole.adminRole[0].roleName : '';
        selecteRole.useraccessLevels = element?.useraccessLevels.map(s => s.roleName).join(",  ");
        // selecteRole.useraccessLevels = element?.useraccessLevels.map(e => e.replace(/\s/g, "")).join(",");
        selecteRole.status = this.userRoles;
        selecteRole.roleSelection = element?.userAccessLevel;
        selecteRole.modifiedUserName = element?.modifiedUserName;
        selecteRole.totalAccountAdminCount = element?.totalAccountAdminCount;

        this.selectedState = element?.userAccessLevel;
        this.defaultSelectedRole = element?.userAccessLevel;
        this.newarray.push(selecteRole);
      });
      this.dataSource = new MatTableDataSource(this.newarray);

      this.setPagination();
      this.statusFilter = data?.data;
      this.collectionUserId = data.collectionUserId;
    }
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(AddUSerDialog, {
      width: '60%',
      panelClass: 'custom-modalbox',
      // disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => { this.noDataFound = false; });
  }

  deleteUser(value): void {

    if (this.roleSer.accessData && this.roleSer.accessData.deleteAllowed) {
      const dialogRef = this.dialog.open(DelMessageComponent, {
        data: {
          message: this.translate.instant('collectionById.collectionUsers.deletePopup.message'),
          buttonText: {
            ok: this.translate.instant('collectionById.collectionUsers.deletePopup.btnYes'),
            cancel: this.translate.instant('collectionById.collectionUsers.deletePopup.btnNo'),
          },
        },
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.collectionService
            .deleteUserfromCollection(this.globalcollectionuuId, value.collectionUsersuuId)
            .subscribe(
              (resData: any) => {
                this.notificationService.success(resData.message); // This line used to display message
                this.collectionService
                  .getCollectionUsers(this.globalcollectionuuId)
                  .subscribe((resData) => {
                    this.getCollectionUserList(resData?.data);
                  });
              },
              (error: any) => {
                this.webErrorService.handleAPIErrors(error, '', true, 'warn'); // This line used to display error message
              }
            );
        }
      });
    }
  }

  ngAfterViewInit(): void {
  }

  onChange(event: any): void {
    if (event === 'status') {
      this.clientStatus = '';
    } else {
      this.clientStatus = event;
    }
  }

  changeRole(value, userData) {


    let findId = this.userRoles.filter(item => item.userAccessLevel === userData.userAccessLevel);
    // Otherwise we want the user to confirm that change


    const dialogRef = this.dialog.open(DelMessageComponent, {

      data: {
        message: 'Are you sure you want to change role for the Collection User?',
        buttonText: {
          ok: 'Yes',
          cancel: 'No',
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      const usertoUpdate = {
        active: true,
        collectionuuId: JSON.parse(userData?.collectionuuId),
        userAccessLevelId: findId[0].userAccessLevelId,
        useruuid: userData?.useruuid,
      };
      if (confirmed) {
        this.collectionService
          .UpdateUserRole(usertoUpdate, userData.collectionUserId)
          .subscribe((value) => { });
      } else {
        this.newarray.forEach((element) => {
          if (element.collectionUserId === userData.collectionUserId) {
            if (element.roleSelection) {
              element.userAccessLevel = element.roleSelection;
            }
          }

        });
        this.dataSource = this.newarray;
      }
    });
  }

  // Search function using api service
  // itemFilter(): void {

  //   const options = 'clientFirstName='+this.clientFirstName
  //   +'&clientLastName='+this.clientLastName
  //   +'&userRoleFilter='+this.userRoleFilter
  //   +'&selectStatus='+this.selectStatus;

  //   this.userFilterServiceSubscription$ = this.usersService.getUsersFilter(options)?.subscribe(
  //     (resData) => {
  //       this.usersData = resData?.items;
  //       if (this.usersData.length === 0) {
  //         this.noDataFound = true;
  //       }
  //       this.usersData = new MatTableDataSource(this.usersData);
  //       this.usersData.sort = this.sort;
  //       this.usersData.paginator = this.paginator;
  //     },
  //     (error) => {
  //       this.router.navigate(["/login"]);

  //     },
  //     () => {
  //     }) || undefined;

  // }

  itemFilter(): void {
    if (this.selectStatus === 'Active' || this.selectStatus === 'Status') {
      this.isActive = true;
    } else {
      this.isActive = false;
    }

    // if (this.clientFirstName == '' && this.clientLastName == '' && this.selectedRole != '') {
    //   this.dataSource.filter = this.selectedRole[0].roleName.trim().toLowerCase();
    //   if (this.dataSource.filteredData.length > 0) {
    //     this.noDataFound = false;
    //   } else {
    //     this.noDataFound = true;
    //   }
    // } else {
      const searchQuery = {
        firstName: encodeURIComponent(this.clientFirstName).trim().toLowerCase(),
        lastName: encodeURIComponent(this.clientLastName).trim().toLowerCase(),
        status: this.isActive,
        role: (this.selectedRole == undefined || this.selectedRole == '') ? '' : this.selectedRole.map(s => s.roleId).join(",")
      };

      this.filterAPI(searchQuery);
    // }
  }

  filterAPI(searchQuery) {
    this.collectionService.getCollectionUserSearch(searchQuery).subscribe(
      (result: any) => {
        result?.data.forEach(element => {
          element.adminRole = element?.useraccessLevels.filter(e => e.roleName == AccountAdminRole.accountAdmin);
          element.adminRole = element.adminRole.length > 0 ? element.adminRole[0].roleName : '';
          element.useraccessLevels = element?.useraccessLevels.map(s => s.roleName).toString();

        });
        this.collectionUserData = result?.data;
        if (this.collectionUserData?.length === 0) {
          this.noDataFound = true;
        } else {
          this.isNoUsers = false;
          this.noDataFound = false;
        }

        this.dataSource = new MatTableDataSource(result?.data);
        this.setPagination();
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); }
    ) || undefined;
  }

  setPagination() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.showPaginator = true
      if (this.dataSource.paginator) {
        this.translate.stream([
          'collectionById.collectionUsers.pagination.pageLabel',
          'collectionById.collectionUsers.pagination.firstPage',
          'collectionById.collectionUsers.pagination.lastPage',
          'collectionById.collectionUsers.pagination.nextPage',
          'collectionById.collectionUsers.pagination.prevPage'
        ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
          this.dataSource.paginator._intl.itemsPerPageLabel = translation['collectionById.collectionUsers.pagination.pageLabel'];
          this.dataSource.paginator._intl.firstPageLabel = translation['collectionById.collectionUsers.pagination.firstPage'];
          this.dataSource.paginator._intl.lastPageLabel = translation['collectionById.collectionUsers.pagination.lastPage'];
          this.dataSource.paginator._intl.nextPageLabel = translation['collectionById.collectionUsers.pagination.nextPage'];
          this.dataSource.paginator._intl.previousPageLabel = translation['collectionById.collectionUsers.pagination.prevPage'];

          this.dataSource.paginator._intl.changes.next();
        });
      }
    });

  }
  resetFilter(): void {
    this.clientFirstName = '';
    this.clientLastName = '';
    this.selectedRole = '';
    this.selectStatus = 'Status';
    this.dataSource = new MatTableDataSource(this.newarray);
    this.dataSource.paginator = this.paginator;
    this.noDataFound = false;
  }

  addNewUser(): void {
    this.addnewUsertoCollection = true;
  }

  ngOnDestroy(): void {
    this.collectionUsersData$.unsubscribe();
  }
}
